import jQuery from 'jquery'
import debugInit from './debug'

var debug = debugInit().log

var $ = jQuery

export default {

  routes: {
    data () {
      return { 
        baseURLForAPI: this.Creek.config.content.baseURLForAPI 
      }
    },
    methods: {

      setTitle (title) {

        //Disable if disabled.
        if (!this.Creek.config.shows.router.enableTitles) {
          return
        }

        if (this.Creek.config.station.title) {
          var append = " - " + this.Creek.config.station.title
        }
        else {
          var append = ""
        }

        $("head title").html(title+append)

      },

      swapPageClass (page) {

        $("body").removeClass (function (index, css) {
          return (css.match (/(^|\s)creek-page-\S+/g) || []).join(' ')
        })
        $("body").addClass("creek-page-"+page)

      },

      activateRoute () {

        debug("Activating Vue.js route.")

      }

    }
  }

}